import React, { useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import FormControl from "react-bootstrap/FormControl";
import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import { Stack } from "react-bootstrap";
import { filesService } from "../services";
import { FileIndex } from "../types";
import { RenameModal, ConfirmDeleteModal } from ".";

const UploadButton: React.FC<{
  refreshFileList: () => void;
  treePath: FileIndex[];
  canDeleteFolder: boolean;
  isAddPhotos?: boolean;
}> = ({ refreshFileList, treePath, canDeleteFolder, isAddPhotos }) => {
  const fileSelector = useRef<HTMLInputElement>(null);
  const [msg, setMsg] = useState<string[]>();
  const [showProgessDialog, setShowProgressDialog] = useState<boolean>(false);
  const [showFolderNameDialog, setShowFolderDialog] = useState<boolean>(false);
  const [showRenameModal, setShowRenameModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [folderIsAlbum, setFolderIsAlbum] = useState<boolean>(false);
  const [newFolderName, setNewFolderName] = useState<string>("");

  const uploadFile = async (
    file: File,
    uploadUrl: string,
    msgs: string[],
    idx: number,
  ) => {
    await filesService.uploadFile(file, uploadUrl, (progress) => {
      console.log(msgs);
      console.log(progress);
      msgs[idx] = `Uploading ${file.name} -- ${progress}%`;
      setMsg([...msgs]);
    });
    msgs[idx] = `Upload ${file.name} complete!`;
    setMsg([...msgs]);
  };

  const handleFiles = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    if (event.target.files) {
      if (event.target.files.length + treePath.length > 30) {
        setMsg(["Error: Cannot upload more than 30 files at a time"]);
        setShowProgressDialog(true);
        setTimeout(() => {
          setShowProgressDialog(false);
          setMsg([]);
        }, 2000);
        return;
      }
      try {
        setMsg(["Fetching upload URLs..."]);
        setShowProgressDialog(true);
        const uploadUrls = await filesService.getUploadUrl(
          event.target.files,
          treePath.length > 0 ? (treePath.at(-1)?.fileName as string) : null,
        );
        let promises = [];
        let newMsgs = [];
        for (let x = 0; x < uploadUrls.length; x++) {
          newMsgs.push(`Uploading ${uploadUrls[x].fileName}...`);
          setMsg(newMsgs);
          promises.push(
            uploadFile(
              event.target.files[x],
              uploadUrls[x].uploadUrl as string,
              newMsgs,
              x,
            ),
          );
        }
        await Promise.all(promises);
        setTimeout(async () => {
          setMsg(["Uploads complete! Refreshing file list..."]);
          await refreshFileList();
          setTimeout(() => {
            setShowProgressDialog(false);
            setMsg([]);
          }, 5000);
        }, 2000);
      } catch (e) {
        console.log(e);
        setMsg(["Error uploading files"]);
        setTimeout(() => {
          setShowProgressDialog(false);
          setMsg([]);
        }, 2000);
      }
    }
  };
  const createNewFolder = async () => {
    await filesService.createNewFolder(newFolderName, folderIsAlbum);
    await refreshFileList();
    setShowFolderDialog(false);
  };
  return (
    <>
      {treePath.length > 0 ? (
        <>
          <RenameModal
            showModal={showRenameModal}
            setShowModal={setShowRenameModal}
            currentDisplayName={treePath.at(-1)?.displayName as string}
            currentFileName={treePath.at(-1)?.fileName as string}
            refreshFileList={refreshFileList}
          />
          <ConfirmDeleteModal
            showModal={showDeleteModal}
            setShowModal={setShowDeleteModal}
            currentFileName={treePath.at(-1)?.fileName as string}
            refreshFileList={refreshFileList}
          />
        </>
      ) : (
        <></>
      )}
      <Modal
        show={showProgessDialog}
        onHide={() => {
          setShowProgressDialog(false);
          refreshFileList();
        }}
        centered
      >
        <Modal.Header closeButton>Uploading Files...</Modal.Header>
        <Modal.Body>
          {msg?.map((m, idx) => (
            <div key={idx}>{m}</div>
          ))}
        </Modal.Body>
      </Modal>
      <Modal
        show={showFolderNameDialog}
        onHide={() => setShowFolderDialog(false)}
      >
        <Modal.Header closeButton>
          Add {folderIsAlbum ? "Photo Album" : "Folder"}
        </Modal.Header>
        <Modal.Body>
          <Stack gap={3}>
            <FormControl
              onChange={(e) => setNewFolderName(e.target.value)}
              value={newFolderName}
              placeholder="Enter name"
            />
          </Stack>
          <Button
            className="mt-3"
            disabled={newFolderName.length === 0}
            onClick={() => createNewFolder()}
          >
            Create Folder
          </Button>
        </Modal.Body>
      </Modal>
      <FormControl
        hidden={true}
        ref={fileSelector}
        type="file"
        multiple
        onChange={handleFiles}
      />
      {/* <Button onClick={() => fileSelector.current?.click()}>Upload</Button> */}
      {isAddPhotos === true ? (
        <Button onClick={() => fileSelector.current?.click()}>
          Add Photos
        </Button>
      ) : (
        <Dropdown>
          <Dropdown.Toggle>Add</Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => fileSelector.current?.click()}>
              Upload file
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setFolderIsAlbum(false);
                setShowFolderDialog(true);
              }}
            >
              Add folder
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setFolderIsAlbum(true);
                setShowFolderDialog(true);
              }}
            >
              Add Photo Album
            </Dropdown.Item>
            {treePath.length > 0 ? (
              <>
                <Dropdown.Item onClick={() => setShowRenameModal(true)}>
                  Rename folder
                </Dropdown.Item>
                <Dropdown.Item
                  disabled={canDeleteFolder}
                  onClick={() => setShowDeleteModal(true)}
                >
                  Delete folder
                </Dropdown.Item>
              </>
            ) : (
              <></>
            )}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
};

export default UploadButton;
